/* eslint-disable */
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface ExportLeaveSummaryPDFPayload {
  startDate?: string;
  endDate?: string;
  departmentId?: string;
  leaveType?: string;
}

export interface ExportLeaveSummaryPDFResponse {
  success: boolean;
  message: string;
  fileUrl?: string;
}

const exportLeaveSummaryPDF = async (
  userId: string,
  orgId: string,
  payload?: ExportLeaveSummaryPDFPayload
): Promise<Blob> => {
  const response = await customAxios.post(
    `/leaves/summary-pdf/${userId}/${orgId}`,
    payload,
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export const useExportLeaveSummaryPDF = () => {
  return useMutation<
    Blob,
    AxiosError,
    { userId: string; orgId: string; payload?: ExportLeaveSummaryPDFPayload }
  >({
    mutationFn: async ({ userId, orgId, payload }) =>
      await exportLeaveSummaryPDF(userId, orgId, payload),
    onSuccess: (data) => {
      const blobUrl = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "leave-summary.pdf";
      link.click();

      showNotification({
        title: "Success",
        message: "Leave summary PDF exported successfully.",
        color: "green",
      });
    },
    onError: (error) =>
      showNotification({
        title: "Error",
        message:
          (error.response?.data as { message?: string })?.message ??
          "Failed to export leave summary PDF",
        color: "red",
      }),
  });
};
